import { useMemo } from 'react';
import { ServiceNotAvailableError } from 'components/content/error/ServiceNotAvailableError';
import { ClientError } from '@cobra/fe-lib/client-error-handling/classes/ClientError';

export const useDisplayErrorForCustomerTypeSelection = (error: ClientError | undefined) =>
    useMemo(() => {
        if (!error) {
            return null;
        }
        return <ServiceNotAvailableError />;
    }, [error]);
